import { Component, EventEmitter, Injector, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { AppComponentBase } from '@shared/common/app-component-base';
import { ContactServiceProxy, CreateFolderDto, OneDriveServiceProxy } from '@shared/service-proxies/service-proxies';

@Component({
  selector: 'vf-select-sharepoint-site-modal',
  templateUrl: './select-sharepoint-site-modal.component.html'
})
export class SelectSharepointSiteModalComponent extends AppComponentBase implements OnChanges {

  @Input() isOpen = false;
  @Output() closed = new EventEmitter<void>();
  @Output() siteSet = new EventEmitter<void>();

  sites: any[] = [];
  filteredSites: any[] = [];
  selectedSite: any = null;
  searchText = '';
  isLoading = false;
  isSaving = false;
  errorMessage = '';

  constructor(
    injector: Injector,
    private _oneDriveService: OneDriveServiceProxy,
    private _contactService: ContactServiceProxy
  ) {
    super(injector);
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.isOpen?.currentValue === true) {
      this.reset();
      this.loadSites();
    }
  }

  private reset() {
    this.sites = [];
    this.filteredSites = [];
    this.selectedSite = null;
    this.searchText = '';
    this.errorMessage = '';
  }

  private loadSites() {
    this.isLoading = true;
    this._oneDriveService.getSharePointSites('').subscribe(
      result => {
        this.isLoading = false;
        if (!result.isError && result.responseData) {
          this.sites = result.responseData;
          this.filteredSites = [...this.sites];
        }
      },
      () => { this.isLoading = false; }
    );
  }

  onSearch() {
    const term = this.searchText.toLowerCase().trim();
    if (!term) {
      this.filteredSites = [...this.sites];
    } else {
      this.filteredSites = this.sites.filter(s =>
        (s.displayName || '').toLowerCase().includes(term) ||
        (s.webUrl || '').toLowerCase().includes(term)
      );
    }
  }

  selectSite(site: any) {
    this.selectedSite = site;
    this.errorMessage = '';
  }

  setAsDefault() {
    if (!this.selectedSite) {
      this.errorMessage = 'Please select a site.';
      return;
    }
    this.isSaving = true;
    this.errorMessage = '';
    const input = new CreateFolderDto();
    input.siteId = this.selectedSite.id;
    input.name = 'Clients';
    input.isDocLibrary = true;
    input.isSharePoint = true;
    input.isUseExisting = false;
    this._contactService.createTenantFolder(input).subscribe(
      result => {
        if (!result.isError) {
          this.isSaving = false;
          this.siteSet.emit();
          this.close();
        } else {
          // Library already exists — retry with isUseExisting = true
          input.isUseExisting = true;
          this._contactService.createTenantFolder(input).subscribe(
            retryResult => {
              this.isSaving = false;
              if (!retryResult.isError) {
                this.siteSet.emit();
                this.close();
              } else {
                this.errorMessage = 'Failed to set storage location. Please try again.';
              }
            },
            () => { this.isSaving = false; this.errorMessage = 'Failed to set storage location. Please try again.'; }
          );
        }
      },
      () => { this.isSaving = false; this.errorMessage = 'Failed to set storage location. Please try again.'; }
    );
  }

  close() {
    this.closed.emit();
  }
}
